var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('MenuLateral'),_c('main',{staticClass:"col-md-8 ml-sm-auto col-lg-9 px-4 mt-3 mb-3",attrs:{"role":"main"}},[_c('router-view')],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }